import Page from '../../../shared/components/Page/Page';
import {Button, Flex, Form, Image, message, Modal, Popconfirm, Space, Table, Tag} from "antd";
import {useContext, useEffect, useState} from "react";
import {createFileName, formatDateTime, numberFormat} from "../../../shared/utils/helpers";
import TextCopy from "../../../shared/components/TextCopy";
import Search from "../../../shared/components/Search/Search";
import { adminGetPayOuts as getPayOuts } from "../api";
import LoadingContext from "../../../app/contexts/LoadingContext";
import {
    AreaChartOutlined,
    CheckOutlined,
    ExportOutlined,
    ReloadOutlined,
    TransactionOutlined
} from "@ant-design/icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faCancel,
    faCheck,
    faDatabase,
    faImage,
    faRepeat,
    faRightToBracket,
    faThumbsUp
} from "@fortawesome/free-solid-svg-icons";
import { callback } from "../api";
import ReadMoreText from "../../../shared/components/ReadMoreText";
import { getLogs } from "../api";
import { cancel } from "../api";
import { complete } from "../api";
import { getBillImage } from "../api";
import { approve } from "../api";
import { retry as retryPayOut } from "../api";
import { getBankAccountTransaction } from "../../bank/api";
import BankAccountTransaction from "../../bank/components/BankTransaction/BankAccountTransaction";
import dayjs from "dayjs";
import { searchPartner } from "../../partner/api";
import { exportFile } from "../api";
import { release } from "../api";
import { toggleState } from "../api";
import styles from "../PayOut.module.css";

function PayOut() {
    const [, contextHolder] = message.useMessage();
    const [tableLoading,setTableLoading] = useState(false);
    const [form] = Form.useForm();
    const [dataSource,setDataSource] = useState([]);
    const {setLoading} = useContext(LoadingContext);
    const [recordLoading, setRecordLoading] = useState({});
    const [openModalLog, setOpenModalLog] = useState(false);
    const [logData, setLogData] = useState([]);
    const [openModalImage, setOpenModalImage] = useState(false);
    const [image, setImage] = useState('');
    const [dataTransaction, setDataTransaction] = useState([]);
    const [openModalTransaction, setOpenModalTransaction] = useState(false);
    const [optionQuery,setOptionQuery] = useState([]);
    const [query,setQuery] = useState('');
    const [summaryData, setSummaryData] = useState({
        totalAmount: 0,
        totalFee: 0,
        totalActualAmount: 0,
    });
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        search: {
            createdAt: [dayjs().startOf('day'), dayjs().endOf('day')]
        }
    });

    const items =  [
        {
            name: 'userId',
            type: 'search',
            placeholder: 'Đối tác',
            options: optionQuery.map((item) => {
                return {
                    value: item.userId,
                    text: item.name
                }
            }),
            onSearch: (value) => {
                setQuery(value)
            }
        },
        {
            name: 'uuid',
            placeholder: 'Mã đơn',
            type: 'text'
        },
        {
            name: 'requestId',
            placeholder: 'Mã tra soát',
            type: 'text'
        },
        {
            name: 'nickname',
            placeholder: 'Nickname',
            type: 'text'
        },
        {
            name: 'accNo',
            placeholder: 'Số tài khoản',
            type: 'text'
        },
        {
            name: 'createdAt',
            placeholder: 'Thời gian',
            type: 'date'
        },
    ];

    const columns = [
        {
            title: 'ID',
            dataIndex: 'uuid',
            align: 'center',
            render: (value) => {
                return <TextCopy value={value}/>
            }
        },
        {
            title: 'Mã tra soát',
            dataIndex: 'requestId',
            align: 'center',
            render: (value) => {
                return <TextCopy value={value}/>
            }
        },
        {
            title: 'Nickname',
            dataIndex: 'nickname',
            width: '150px',
            align: 'center',
            render: (value) => {
                return <TextCopy value={value}/>
            }
        },
        {
            title: 'Đối tác',
            dataIndex: 'username',
            align: 'center',
            render: (value) => {
                return <Tag>{value}</Tag>
            }
        },
        {
            title: 'Ngân hàng',
            dataIndex: 'bankName',
            align: 'center'
        },
        {
            title: 'Số tài khoản',
            dataIndex: 'accNo',
            align: 'center',
            render: (value) => {
                return <TextCopy value={value}/>
            }
        },
        {
            title: 'Tên tài khoản',
            dataIndex: 'accName',
            align: 'center',
            render: (value) => {
                return <Tag>{value}</Tag>
            }
        },
        {
            title: 'Số tiền',
            dataIndex: 'amount',
            align: 'center',
            sorter: true,
            render: (value) => {
                return numberFormat(value)
            }
        },
        {
            title: 'Phí',
            dataIndex: 'fee',
            align: 'center',
            render: (value) => {
                return numberFormat(value)
            }
        },
        {
            title: 'Tiền trừ',
            dataIndex: 'actualAmount',
            align: 'center',
            sorter: true,
            render: (value) => {
                return numberFormat(value)
            }
        },
        {
            title: 'Nội dung',
            dataIndex: 'content',
            align: 'center'
        },
        {
            title: 'Duyệt',
            dataIndex: 'isApproved',
            align: 'center',
            filters: [
                {
                    text: 'Đã duyệt',
                    value: true
                },
                {
                    text: 'Chờ duyệt',
                    value: false
                }
            ],
            render: (value) => {
                if(value) {
                    return <Tag color={'green'}>Đã duyệt</Tag>
                }
                return <Tag color={'red'}>Chờ duyệt</Tag>
            }
        },
        {
            title: 'Trạng thái',
            dataIndex: 'status',
            align: 'center',
            filters: [
                {
                    text: 'Đã hoàn thành',
                    value: true
                },
                {
                    text: 'Chưa hoàn thành',
                    value: false
                }
            ],
            render: (value) => {
                if(value) {
                    return <Tag color={'green'}>Đã hoàn thành</Tag>
                }
                return <Tag color={'red'}>Chưa hoàn thành</Tag>
            }
        },
        {
            title: 'Tình trạng',
            dataIndex: 'statusCode',
            align: 'center',
            filters: [
                {
                    text: 'Thành công',
                    value: 0
                },
                {
                    text: 'Bị hủy',
                    value: -6
                },
                {
                    text: 'Sai tên',
                    value: -5
                }
            ],
            render: (value) => {
                if (value === 0) {
                    return <Tag color={'green'}>Thành công</Tag>
                }else if (value === 1) {
                    return <Tag color={'yellow'}>Đang chờ</Tag>
                }else if(value === 2) {
                    return <Tag color={'blue'}>Kiểm tra tên</Tag>
                }else if (value === 3) {
                    return <Tag color={'blue'}>Đang thực hiện</Tag>
                }else if (value === 4) {
                    return <Tag color={'blue'}>Duyệt lệnh</Tag>
                }else if (value === -5) {
                    return <Tag color={'red'}>Tên không khớp</Tag>
                }else if (value === -1) {
                    return <Tag color={'red'}>Kiểm tra lại</Tag>
                }else if (value === -6) {
                    return <Tag color={'red'}>Bị hủy</Tag>
                }
            }
        },
        {
            title: 'Trạng thái CB',
            dataIndex: 'isCallback',
            align: 'center',
            filters: [
                {
                    text: 'Đã callback',
                    value: true
                },
                {
                    text: 'Chưa callback',
                    value: false
                },
            ],
            render: (value) => {
                if (value) {
                    return <Tag color={'success'}>Đã CALLBACK</Tag>
                }
                return <Tag color={'yellow'}>Chưa CALLBACK</Tag>
            }
        },
        {
            title: 'Hoàn tiền',
            dataIndex: 'isRefunded',
            align: 'center',
            render: (value) => {
                if (value) {
                    return <Tag color={'success'}>Đã hoàn</Tag>
                }
            }
        },
        {
            title: 'Thời gian tạo',
            dataIndex: 'createdAt',
            align: 'center',
            sorter: true,
            render: (value)  => {
                return (
                    <Tag>{formatDateTime(value)}</Tag>
                )
            }
        },
        {
            title: 'Thời gian hoàn thành',
            dataIndex: 'completedAt',
            align: 'center',
            sorter: true,
            render: (value)  => {
                if (value) {
                    return (
                        <Tag>{formatDateTime(value)}</Tag>
                    )
                }
            }
        },
        {
            title: 'Địa chỉ IP',
            dataIndex: 'ipAddress',
            align: 'center',
            render: (value) => {
                return <Tag>{value}</Tag>
            }
        },
        {
            title: 'Xử lý',
            dataIndex: 'handler',
            align: 'center',
            render: (value) => {
                if (!value) {
                    return (
                        <Tag>Hệ thống</Tag>
                    )
                }
                return (
                    <Tag color={'blue'}>{value}</Tag>
                )
            }
        },
        {
            title: 'Hành động',
            dataIndex: 'operation',
            align: 'center',
            render: (_,record) => {
                return (
                    <Space>
                        <Button onClick={() => handleOpenModalLog(record.payOutId)} title={'Log'} icon={<FontAwesomeIcon icon={faDatabase}/>}/>
                        {!record.isApproved && (
                            <Popconfirm
                                title="Duyệt đơn"
                                description="Bạn muốn duyệt đơn xuất khoản này?"
                                onConfirm={() => handleApprovePayOut(record.uuid)}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button loading={!!recordLoading[record.uuid]} type={'primary'} icon={<FontAwesomeIcon icon={faThumbsUp}/>} title={'Duyệt'}/>
                            </Popconfirm>
                        )}
                        {record.status && (
                            <Popconfirm
                                title="Re callback"
                                description="Bạn muốn gửi lại yêu cầu callback?"
                                onConfirm={() => handleCallbackPayOut(record.uuid)}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button loading={!!recordLoading[record.uuid]} type={'primary'} icon={<FontAwesomeIcon icon={faRightToBracket}/>} title={'Callback'}/>
                            </Popconfirm>
                        )}
                        {(!record.status && [-1,1].includes(record.statusCode)) && (
                            <Popconfirm
                                title="Hủy giao dịch"
                                description="Bạn muốn hủy giao dịch và hoàn lại tiền cho đối tác?"
                                onConfirm={() => handleCancelPayOut(record.uuid)}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button loading={!!recordLoading[record.uuid]} danger={true} icon={<FontAwesomeIcon icon={faCancel}/>} title={'Hủy'}/>
                            </Popconfirm>
                        )}
                        {(!record.status && record.statusCode === -1) && (
                            <Popconfirm
                                title="Thành công"
                                description="Bạn muốn xác nhận giao dịch đã thực hiện thành công?"
                                onConfirm={() => handleOkePayOut(record.uuid)}
                                okText="Yes"
                                cancelText="No"
                                icon={<CheckOutlined/>}
                            >
                                <Button loading={!!recordLoading[record.uuid]} type={'primary'} icon={<FontAwesomeIcon icon={faCheck}/>} title={'Thành công'}/>
                            </Popconfirm>
                        )}
                        {(record.status && record.statusCode === 0) && (
                            <Button onClick={() => handleGetBillImage(record.uuid)} loading={!!recordLoading[record.uuid]} type={'primary'} icon={<FontAwesomeIcon icon={faImage}/>} title={'Lấy Bill'}/>
                        )}
                        {(!record.status && record.statusCode === -1) && (
                            <Popconfirm
                                title="Thực hiện lại"
                                description="Bạn muốn thực hiện lại giao dịch này?"
                                onConfirm={() => handleRetryPayOut(record.uuid)}
                                okText="Yes"
                                cancelText="No"
                                icon={<CheckOutlined/>}
                            >
                                <Button loading={!!recordLoading[record.uuid]} type={'primary'} icon={<FontAwesomeIcon icon={faRepeat}/>} title={'Thực hiện lại'}/>
                            </Popconfirm>
                        )}
                    </Space>
                )
            }
        }
    ];

    const logColumns = [
        {
            title: 'ID',
            dataIndex: 'uuid',
            align: 'center',
            width: '240px'
        },
        {
            title: 'Tài khoản',
            dataIndex: 'bankAccount',
            align: 'center',
            width: '200px',
            render: (_, record) => {
                return (
                    <Flex vertical={true} justify={'center'} align={'center'} gap={'small'}>
                        <Tag color={'#53c8f3'}>{record.bankName}</Tag>
                        <TextCopy value={record.accountNumber}/>
                    </Flex>
                )
            }
        },
        {
            title: 'Trạng thái',
            dataIndex: 'status',
            align: 'center',
            width: '200px',
            render: (value) => {
                if (value) {
                    return <Tag color={'blue'}>Hoàn thành</Tag>
                }
                return <Tag color={'blue'}>Đang thực hiện</Tag>
            }
        },
        {
            title: 'Lỗi',
            dataIndex: 'isError',
            align: 'center',
            width: '200px',
            render: (value) => {
                if (value) {
                    return <Tag color={'red'}>Lỗi</Tag>
                }
            }
        },
        {
            title: 'Tình trạng',
            dataIndex: 'state',
            align: 'center',
            width: '200px',
            render: (value) => {
                if (value === 'validate') {
                    return <Tag color={'yellow'}>Kiểm tra tên</Tag>
                } else if (value === 'transfer') {
                    return <Tag color={'blue'}>Tạo lệnh chuyển</Tag>
                } else if (value === 'wait_otp') {
                    return <Tag color={'blue'}>Xác thực OTP</Tag>
                } else if (value === 'processed') {
                    return <Tag color={'green'}>Hoàn thành</Tag>
                } else if (value === 'wait_approve') {
                    return <Tag color={'blue'}>Chờ duyệt</Tag>
                }
            }
        },
        {
            title: 'Thông tin',
            dataIndex: 'message',
            align: 'center'
        },
        {
            title: 'Chi tiết lỗi',
            dataIndex: 'exception',
            align: 'center',
            render: (value) => {
                if (value){
                    return <ReadMoreText text={value} maxLength={100}/>
                }
            }
        },
        {
            title: 'Đối tượng',
            dataIndex: 'target',
            align: 'center',
            render: (value) => {
                return <Tag color={'#55acee'}>{value}</Tag>
            }
        },
        {
            title: 'Thời gian tạo',
            dataIndex: 'createdAt',
            sorter: true,
            align: 'center',
            width: '200px',
            render: (value)  => {
                return (
                    <Tag>{formatDateTime(value)}</Tag>
                )
            }
        },
        {
            title: 'Hành động',
            dataIndex: 'operation',
            align: 'center',
            render: (_,record) => {
                return (
                    <Space>
                        <Button icon={<TransactionOutlined/>} title={'Xem giao dịch'} onClick={() => handleGetBankAccountTransaction(record.bankAccountId)}/>
                        {!record.status && (
                            <Popconfirm
                                title="Bạn có chắc chắn muốn xử lý đơn treo này không?"
                                onConfirm={() => handleLockTransaction(record.uuid)} // Thực hiện hành động khi xác nhận
                                okText="Đồng ý"
                                cancelText="Hủy"
                            >
                                <Button
                                    danger={true}
                                    icon={<ReloadOutlined />}
                                    title={'Xử lý đơn treo'}
                                />
                            </Popconfirm>
                        )}
                        {record.status && (
                            <Popconfirm
                                title="Bạn có chắc chắn muốn chuyển trạng thái đơn này không?"
                                onConfirm={() => handleToggleState(record.uuid)} // Thực hiện hành động khi xác nhận
                                okText="Đồng ý"
                                cancelText="Hủy"
                            >
                                <Button
                                    danger={false}
                                    type={'primary'}
                                    icon={<AreaChartOutlined />}
                                    title={'Chuyển trạng thái'}
                                />
                            </Popconfirm>
                        )}
                    </Space>
                )
            }
        }
    ];

    const handleLockTransaction = async (uuid) => {
        setLoading(true);
        const response = await release(uuid);
        if (response.success) {
            message.success('Thành công');
        }
        else {
            message.error(response.message);
        }
        setLoading(false);
    }

    const handleToggleState = async (uuid) => {
        setLoading(true);
        const response = await toggleState(uuid);
        if (response.success) {
            message.success('Thành công');
        }
        else {
            message.error(response.message);
        }
        setLoading(false);
    }

    const handleGetBankAccountTransaction = async (id) => {
        setLoading(true);
        const response = await getBankAccountTransaction( id);
        if (response.success) {
            setOpenModalTransaction(true);
            setDataTransaction(response.data);
        }
        setLoading(false);
    }

    const save =  async (uuid, data) => {
        try {
            const newData = [...dataSource];
            const index = newData.findIndex((item) => uuid === item.uuid);
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {
                    ...item,
                    ...data,
                });
                setDataSource(newData);
            } else {
                newData.push(data);
                setDataSource(newData);
            }
        } catch (e) {
            console.log('Validate Failed:', e);
        }
        finally {
        }
    }

    const handleGetBillImage = async (uuid) => {
        setRecordLoading(prev => ({ ...prev, [uuid]: true }));
        const response = await getBillImage( uuid);
        if (response.success) {
            setImage(response.data.image);
            setOpenModalImage(true);
            message.success('Lấy ảnh giao dịch thành công');
        } else {
            message.error(response.message);
        }
        setRecordLoading(prev => ({ ...prev, [uuid]: false }));
    }

    const handleCancelPayOut = async (uuid) => {
        setRecordLoading(prev => ({ ...prev, [uuid]: true }));
        const response = await cancel( uuid);
        if (response.success) {
            await save(uuid, response.data);
            message.success('Hủy và hoàn tiền giao dịch thành công');
        } else {
            message.error(response.message);
        }
        setRecordLoading(prev => ({ ...prev, [uuid]: false }));
    }

    const handleOkePayOut = async (uuid) => {
        setRecordLoading(prev => ({ ...prev, [uuid]: true }));
        const response = await complete( uuid);
        if (response.success) {
            await save(uuid, response.data);
            message.success('Cập nhật giao dịch thành công');
        } else {
            message.error(response.message);
        }
        setRecordLoading(prev => ({ ...prev, [uuid]: false }));
    }

    const handleRetryPayOut = async (uuid) => {
        setRecordLoading(prev => ({ ...prev, [uuid]: true }));
        const response = await retryPayOut( uuid);
        if (response.success) {
            await save(uuid, response.data);
            message.success('Thực hiện lại đơn thành công');
        } else {
            message.error(response.message);
        }
        setRecordLoading(prev => ({ ...prev, [uuid]: false }));
    }

    const handleApprovePayOut = async (uuid) => {
        setRecordLoading(prev => ({ ...prev, [uuid]: true }));
        const response = await approve( uuid);
        if (response.success) {
            await save(uuid, response.data);
            message.success('Đã duyệt giao dịch thành công');
        } else {
            message.error(response.message);
        }
        setRecordLoading(prev => ({ ...prev, [uuid]: false }));
    }

    const handleCallbackPayOut = async (uuid) => {
        setRecordLoading(prev => ({ ...prev, [uuid]: true }));
        const response = await callback( uuid);
        if (response.success) {
            message.success('Gửi yêu cầu callback thành công');
        } else {
            message.error(response.message);
        }
        setRecordLoading(prev => ({ ...prev, [uuid]: false }));
    }

    const handleSearch = () => {
        const params = form.getFieldsValue();
        setTableParams({
            ...tableParams,
            search: {
                ...params
            }
        })
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            ...tableParams,
            pagination,
            filters,
            sorter,
        });
    };

    const handleExportFile = async () => {
        setLoading(true);
        const response = await exportFile( tableParams.search, createFileName('bank_transaction', 'xlsx'));
        if (!response.success) {
            message.error(response.message);
        }
        setLoading(false);
    }

    const fetchDataPayOuts = async () => {
        setTableLoading(true);
        const response = await getPayOuts( tableParams);
        if (response.success) {
            setDataSource(response.data.data);
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    total: response.data.total
                },
            });
            setSummaryData({
                totalAmount: response.data.totalAmount,
                totalFee: response.data.totalFee,
                totalActualAmount: response.data.totalActualAmount,
            })
        }
        setTableLoading(false);
    }

    const handleOpenModalLog = async (payOutId) => {
        setLoading(true);
        const response = await getLogs( payOutId);
        if (response.success) {
            setOpenModalLog(true);
            setLogData(response.data.data);
        }
        setLoading(false);
    }

    useEffect(() => {
        fetchDataPayOuts().finally();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        tableParams?.sorter,
        tableParams?.search,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.filters)
    ]);

    useEffect(() => {
        setLoading(true);
        const fetchPartners = async () => {
            const response = await searchPartner(query);
            if (response.success) {
                setOptionQuery(response.data)
            }
        }
        fetchPartners().finally(setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])

    return (
        <Page title="Pay out" className={styles.payOutContainer}>
            {contextHolder}
            <Space className={styles.actionBar}>
                <Button icon={<ReloadOutlined/>} onClick={() => fetchDataPayOuts()}>Làm mới</Button>
                <Button onClick={handleExportFile} type={'primary'} icon={<ExportOutlined/>} title={'Xuất file'}>Xuất file</Button>
            </Space>
            <Search
                items={items}
                form={form}
                onSearch={handleSearch}
            />
            <div className={styles.tableContainer}>
                <Table
                    rowKey={'uuid'}
                    columns={columns}
                    scroll={{
                        x: 2400,
                    }}
                    bordered={true}
                    loading={tableLoading}
                    dataSource={dataSource}
                    onChange={handleTableChange}
                    pagination={tableParams.pagination}
                    summary={(data) => {
                        return (
                            <Table.Summary.Row className={styles.summaryRow}>
                                <Table.Summary.Cell className={styles.summaryCell} index={0} colSpan={7}>
                                    Thống kê
                                </Table.Summary.Cell>
                                <Table.Summary.Cell className={styles.summaryCell} index={1} align={'center'} colSpan={1}>
                                    <Tag className={styles.summaryTag} color={'blue'}>{numberFormat(summaryData.totalAmount)}</Tag>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell className={styles.summaryCell} index={1} align={'center'} colSpan={1}>
                                    <Tag className={styles.summaryTag} color={'blue'}>{numberFormat(summaryData.totalFee)}</Tag>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell className={styles.summaryCell} index={2} align={'center'} colSpan={1}>
                                    <Tag className={styles.summaryTag} color={'blue'}>{numberFormat(summaryData.totalActualAmount)}</Tag>
                                </Table.Summary.Cell>
                            </Table.Summary.Row>
                        );
                    }}
                />
            </div>
            <Modal
                title={'Lịch sử pay out'}
                open={openModalLog}
                onCancel={() => setOpenModalLog(false)}
                footer={null}
                width={'50%'}
                className={styles.logModal}
                bodyStyle={{ maxHeight: '80vh', overflowY: 'auto' }}
            >
                <Table
                    rowKey={'uuid'}
                    columns={logColumns}
                    dataSource={logData}
                    bordered={true}
                    scroll={{
                        x: 2000,
                    }}
                />
            </Modal>
            <Modal
                title={'Ảnh giao dịch chuyển khoản'}
                open={openModalImage}
                onCancel={() => setOpenModalImage(false)}
                footer={null}
                className={styles.modalContainer}
            >
                <Image className={styles.modalImage} src={image}/>
            </Modal>
            <BankAccountTransaction
                open={openModalTransaction}
                setOpen={setOpenModalTransaction}
                dataSource={dataTransaction}
                width={'50%'}
                className={styles.transactionModal}
            />
        </Page>
    )
}

export default PayOut;
